export default {
    url: '',
    template: '<survey-list sites="vm.sites" apg="vm.apg" survey_manage_sites="vm.surveyManageSites"></survey-list>',
    resolve: {
        sites: (SiteResource, ROLE_COMPANY_MODULE_PRIVILEGE_ENUM) => {
            return SiteResource.query({
                'filterByPrivileges[]': ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.FORMS_SURVEY_CSV_EXPORT,
                fields: 'id,name',
                pageSize: 0
            }).$promise;
        },
        apg: (AutomatedPlanningGroupResource) => {
            return AutomatedPlanningGroupResource.query({
                fields: 'id,name',
                pageSize: 0
            }).$promise;
        },
        surveyManageSites: (SiteResource, ROLE_COMPANY_MODULE_PRIVILEGE_ENUM) => {
            return SiteResource.query({
                'filterByPrivileges[]': ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.FORMS_SURVEY_MANAGE,
                fields: 'id,name',
                pageSize: 0
            }).$promise;
        }
    },
    controller (sites, apg, surveyManageSites) {
        this.sites = sites;
        this.apg = apg;
        this.surveyManageSites = surveyManageSites;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/survey/list/index.js